export const resourcePath = '../listing/'

export const singleFamilyHomeIcon = 'single-fam.svg'
export const manufacturedHomeIcon = 'home-mobile-home.svg'
export const apartmentIcon = 'condo-apt.svg'
export const multiFamilyHomeIcon = 'multi-fam.svg'
export const bathroomIcon = 'bathrooms.svg'
export const bedroomIcon = 'bedroom.svg'
export const squareFeetIcon = 'square-ft.svg'
export const yearBuiltIcon = 'year-built.svg'
export const BATH_ROOM_LABELS = {
  0: '0',
  0.5: '0.5',
  1: '1',
  1.5: '1.5',
  2: '2',
  2.5: '2.5',
  3: '3',
  3.5: '3.5',
  4: '4',
  4.5: '4.5',
  5: '5',
  5.5: '5.5',
  6: '6+',
}

export const BED_ROOM_LABELS = {
  0: 0,
  1: 1,
  2: 2,
  3: 3,
  4: 4,
  5: 5,
  6: 6,
  7: 7,
  8: 8,
  9: 9,
  10: '10+',
}
